import React, { useEffect, useState } from 'react'

import { FormWrapper } from '@/components/Forms/styles'

import { useTranslation } from 'react-i18next'

const FormRequestNewPassword = props => {
  const {
    userNameState,
    userNameHandler,
    requestTokenHandler,
    screenHandler,
    screenIds
  } = props

  const { t } = useTranslation()

  const [labelsEmail, setLabelsEmail] = useState('')
  const [placeholdersEmail, setPlaceholdersEmail] = useState('')
  const [titlesSignin, setTitlesSignin] = useState('')
  const [titlesForgotPassword, setTitlesForgotPassword] = useState('')
  const [subtitlesResetToken, setSubtitlesResetToken] = useState('')
  const [buttonsSendToken, setButtonsSendToken] = useState('')

  useEffect(() => {
    setLabelsEmail(t('labels.email'))
    setPlaceholdersEmail(t('placeholders.email'))
    setTitlesSignin(t('titles.signin'))
    setTitlesForgotPassword(t('titles.forgotPassword'))
    setSubtitlesResetToken(t('subtitles.resetToken'))
    setButtonsSendToken(t('buttons.sendToken'))
  }, [t])

  const switchToLoginScreen = () => {
    screenHandler(screenIds.login)
  }

  const handleSubmit = e => {
    e.preventDefault()
    requestTokenHandler()
  }

  return (
    <div id="forgot-password">
      <div className="title">
        <h1>{titlesForgotPassword}</h1>
        <h2>{subtitlesResetToken}</h2>
      </div>

      <FormWrapper onSubmit={handleSubmit}>
        <section>
          <label>{labelsEmail}</label>
          <input
            id="inp_email_request_pass"
            type="email"
            placeholder={placeholdersEmail}
            value={userNameState}
            onChange={e => userNameHandler(e.target.value)}
          />
        </section>

        <button id="btn_sendtoken" type="submit" className="btn lg blue">
          {buttonsSendToken}
        </button>
        <button
          id="btn_back"
          type="button"
          className="icon-button"
          onClick={switchToLoginScreen}
        >
          <div className="flexbox v-centered">
            <span className="material-icons">arrow_back</span>
            <span>{titlesSignin}</span>
          </div>
        </button>
      </FormWrapper>
    </div>
  )
}

export default FormRequestNewPassword
